export enum ProductAttributes {
  color = 'COLOR',
  size = 'SIZE',
  variant = 'VARIANT'
}

export default ProductAttributes
